import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from "@angular/material/snack-bar";
import { ReferrerPortalService } from '../referrer-portal.service';
import { DOCUMENT_TAG } from 'src/app/models/constants/document-tag.model';
import moment from 'moment';
import { PatientCaseWorkItemFormDataModel } from 'src/app/models/forms/data/patient-case-work-item-form-data.model';
import { Globals } from 'src/app/globals';
import { DataARLedgerListModel } from '../../ar/models/data-ar-ledger-list.model';
import { MessagingService } from 'src/app/services/messaging.service';
import { UserService } from 'src/app/services/user.service';
import { StaticDataService } from 'src/app/services/static-data.service';
import { TdoTableSelectionEvent } from 'src/app/tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import { ReferralDataModel } from '../../configuration/referral-configuration/models/referral-data.model';
import { FormatPhoneNumberPipe, FormatPhonePipe } from 'src/app/pipes/format-phone.pipe';
import { DiscomfortLevelList } from 'src/app/constants';
import { ToastrService } from 'ngx-toastr';
import { Sort } from '@angular/material/sort';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { TdoTableV2Component } from 'src/app/tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import { TdoSearchEvent } from 'src/app/tdo-controls/common/tdo-search/models/TdoSearchEvent';
import { error } from 'console';
import { TdoTableRowModel } from 'src/app/tdo-controls/common/tdo-table-v2/models/tdo-table-row.model';
@Component({
  selector: 'app-referrer-portal-home',
  templateUrl: './referrer-portal-home.component.html',
  styleUrls: ['./referrer-portal-home.component.css']
})
export class ReferrerPortalHomeComponent implements OnInit {
  @ViewChild('referralsTable') referralsTable: TdoTableV2Component;

  isLoading: boolean = true;
  referrerInformation: any = {};
  referrerId: string;

  patientEmail: string;
  patientAddress: string;

  referralsInfo: ReferralDataModel[] = [];
  selectedReferral: ReferralDataModel;
  searchPredicate: (data: any, filter: string) => boolean;
  datePickerStart = new Date();
  datePickerEnd = new Date();
  searchText: string ='';
  minSearchDate: Date = new Date();
  maxSearchDate: Date = new Date();

  constructor(
    private staticDataService: StaticDataService,
    private router: Router,
    private referrerPortalService: ReferrerPortalService,
    private snackBar: MatSnackBar,
    private toastr: ToastrService

  ) {
    this.minSearchDate.setDate(this.maxSearchDate.getDate() - 60);
    this.referrerInformation = JSON.parse(localStorage.getItem('storedReferrerUser'));
    this.referrerId = this.referrerInformation.authdata.doctorId;
    this.searchPredicate = (dataSearch: TdoTableRowModel, filter: string) => {
      const rowCreated = new Date(dataSearch.model.xauditCreatedOn);
      //entrytext will contain all fields to search in
      const entryText = dataSearch.model.Patient_FirstName + ' ' + dataSearch.model.Patient_MidName + ' ' + dataSearch.model.Patient_LastName + ' ' 
            + dataSearch.model.Patient_Email + ' ' + dataSearch.model.Patient_Phone;
      return entryText.toLowerCase().includes(this.searchText) && rowCreated >= this.datePickerStart && rowCreated <= this.datePickerEnd;
    };
  }

  ngOnInit() {

    this.datePickerStart.setDate(this.datePickerStart.getDate() -60);
    this.isLoading = true;
    if (!this.staticDataService.isReady) {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.init();

        }
      });
      this.staticDataService.refreshValues();
    }
    else
      this.init();

  }

  init() {
    // add QR code icon that opens check in
    // create a new 'confirm appointment' page
    // disable confirm if already confirmed
    var promises = [
      this.getReferrals(this.referrerId),
      //   this.getPatientAppointments(),
    ];

    this.isLoading = true;

    Promise.all(promises).then((results: any[]) => {

      var refs: ReferralDataModel[] = results[0];
      refs.forEach(referral => {
        referral.StatusName = this.staticDataService.getValidValueItemByItemId(referral.enumReferralStatusID)?.ItemDisplayValue;
        if (referral.DiscomfortLevel)
          referral.DiscomfortLevelDescription = DiscomfortLevelList[referral.DiscomfortLevel].value;
      }
      );
      this.referralsInfo = refs;
      this.isLoading = false;
    }, err => {
      this.displayMessage( 'Error','Error retrieving the referral records.');
      this.isLoading = false;
    }
    );

  }

  getFormatedTime(hour: number, minutes: number) {
    var timePeriod = 'am';
    if (hour >= 12) {
      timePeriod = 'pm';
    }

    if (hour > 12) {
      hour = hour - 12;
    }

    var newMinutes = ''

    if (minutes < 10) {
      newMinutes = `0${minutes}`;
    } else {
      newMinutes = `${minutes}`;
    }

    return `${hour}:${newMinutes}${timePeriod}`
  }

  getReferrals(referrerId: string) {
    let promise = new Promise((resolve, reject) => {
      this.referrerPortalService.getReferrerals(referrerId)
        .subscribe(resolve, reject);
    });
    return promise;
  }
  // Handle selection and deselection of rows model data
  onRowSelected(event: TdoTableSelectionEvent) {
    this.selectedReferral = event.model;
  }

  editProfilePressed() {
    this.router.navigate(['/patientportal/profile']);
  }

  navigateToForm(task) {
    this.router.navigate([`/patientportal/form/${task.CaseWorkItemFormsId}`])
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  onSearchDateChange(event: MatDatepickerInputEvent<Date, Date | null>) {
    this.applySearch();
  }

  displayMessage(type, message) {
    if (type.toLowerCase() === "error")
      this.toastr.error(message, null, {timeOut:7000});
    else
      this.toastr.success(message, null, {timeOut:3000});      
  }

  

  onSearchInput(event) {
    this.applySearch();
  }

  onClearSearch() {
    this.searchText = '';
    this.applySearch();

  }

  onTextSearch(event: string) {
    this.applySearch();
  }
  applySearchFilter(event: TdoSearchEvent): void {
    this.searchText = event.value.toLocaleLowerCase();
    this.applySearch();
  }

  applySearch(){
    const ev = new TdoSearchEvent(this.searchText);
    this.referralsTable.applySearchFilter(ev);
  }
}
